import { ComponentType, useState } from 'react';

import { MajorSurvey } from '@components/MajorSurvey';
import { SurveySuccessDialog } from '@components/SurveySuccessDialog';

export interface WithMajorSurveyModalProps {
  onOpenSurvey: (programCipCode: string) => void;
  onMajorCardUpdated?: () => void;
}

export type MajorSurveyModalProps = Partial<WithMajorSurveyModalProps>;

export const withMajorSurveyModal =
  <T extends MajorSurveyModalProps>(WrappedComponent: ComponentType<T>) =>
  (props: T & MajorSurveyModalProps) => {
    const [programCipCode, setProgramCipCode] = useState<string | null>(null);
    const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState(false);

    const handleOpenSurvey = (cipCode: string) => {
      setProgramCipCode(cipCode);
    };

    const handleCloseSurvey = () => {
      setProgramCipCode(null);
    };

    const handleOpenSuccessDialog = () => {
      setIsOpenSuccessDialog(true);
    };

    const handleCloseSuccessDialog = () => {
      setIsOpenSuccessDialog(false);
      props.onMajorCardUpdated && props.onMajorCardUpdated();
    };

    return (
      <>
        <WrappedComponent {...(props as T)} onOpenSurvey={handleOpenSurvey} />

        {programCipCode && (
          <MajorSurvey
            isOpenSurvey={!!programCipCode}
            onCloseSurvey={handleCloseSurvey}
            programCipCode={programCipCode}
            onOpenSuccessDialog={handleOpenSuccessDialog}
          />
        )}

        {isOpenSuccessDialog && (
          <SurveySuccessDialog
            surveyType="major"
            isOpenSuccessDialog={isOpenSuccessDialog}
            onCloseSuccessDialog={handleCloseSuccessDialog}
          />
        )}
      </>
    );
  };
